import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const segment = window.location.pathname.split("/")[1];
const savedLang = localStorage.getItem("sot-language");
const urlLocale = new URLSearchParams(window.location.search).get("locale");

let lng = "en-US";
if (segment === "ca") {
  const queryLang = urlLocale?.endsWith("-CA") ? urlLocale : null;
  if (queryLang) {
    localStorage.setItem("sot-language", queryLang);
  }
  lng = queryLang ?? (savedLang?.endsWith("-CA") ? savedLang : "en-CA");
} else if (segment === "uk") {
  lng = "en-GB";
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng,
    fallbackLng: "en-US",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: ["translation", "statements"],
    defaultNS: "translation",
    react: {
      useSuspense: false,
    },
  });

export default i18n;
